import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div>
        <footer>
          <div className="container">
            <p className="copyright">
              &copy; 2019{' '}
              <a href="https://www.crystalpayroll.com" target="_blank">
                Crystal Payroll Ltd.
              </a>{' '}
              All Rights Reserved.
            </p>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;
